/** Split a required field name into his required type and field name
 *
 * @param {string} name e.g. 'E_name_of_field_elementId'
 * @returns {{required_type: 'I'|'C'|'L'|'D'|'E'|'P', field: string}}
 *
 * @example
 *  splitRequiredFromField('E_name_of_field_elementId')
 * returns  {required_type: 'E' field, field: 'name_of_field_elementId'}
 *
 * @info required_type: \
 *
 * I -> Internal Value from the same element \
 * C -> External Value from a child element \
 * L -> gets a value from a location \
 *  \
 * D -> Value from Parent to calculate output quantities -> goes in extra Queue and must be calculated first (downQueue) \
 *    \
 * Must only be used for final values to avoid looping calculations -> goes in extra queue and must be calculated last (extraQueue): \
 * E -> Value from a parent \
 * P -> Value from associated part (can be accesed via location variable because it uses at all times location from parent)    \
 *
 *
 */
export function splitRequiredFromField(name) {
  const [type, field] = name.split(/_(.*)/s); // Split on first underscore;

  return { required_type: type, field };
}

export function isLocationType(id: string) {
  if (!id) return false;
  return [
    "location",
    "shift",
    "shiftModel",
    "shiftModelDeduction",
    "activity",
    "nonWageLaborCost"
  ].includes(id.split("_")[1]);
}

export const numericFieldInTable = ({
  t,
  entity,
  field,
  sortable = true,
  maximumFractionDigits = 2
}) => {
  return {
    title: t(`entities.${entity}.fields.${field}`),
    key: field,
    sortable,
    value: (item) =>
      new Intl.NumberFormat("de-DE", { maximumFractionDigits }).format(
        item[field]
      ) ?? 0
  };
};

export const stringFieldInTable = ({ t, entity, field, sortable = false }) => {
  return {
    title: t(`entities.${entity}.fields.${field}`),
    key: field,
    sortable
  };
};

const showGroups = ["calculation"];

// export function log(message, level = "info", group = "global") {
//   if (level === "error") {
//     console.error(message);
//   }
//   if (import.meta.env.MODE === "development") {
//     if (level === "warning") {
//       console.warn(message);
//     } else {
//       if (group === "global") {
//         console.log(message);
//       } else if (showGroups.includes(group)) {
//         console.log(message);
//       }
//     }
//   }
// }

// export function warn(message) {
//   log(message, "warn");
// }

// export function error(message) {
//   log(message, "error");
// }
